import axios from 'axios';

const state = {
    history: "",
    contacts: [],
    chats: [],
    chat_lists: []
};

const getters = {

};

const actions = {
    history_chat_lists({ commit }, data) {
        return new Promise((resolve, reject) => { 
            const params = new URLSearchParams();
            if (data.limit) {
                params.append('limit', data.limit);
            }
            if (data.before_timestamp) {
                params.append('before_timestamp', data.before_timestamp);
            }
            
            const url = 'history/chat-lists/' + data.id + (params.toString() ? '?' + params.toString() : '');
            axios.get(url)
            .then(response => {
                commit("PUSH_HISTORY", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
    history_chats({ commit }, data) {
        return new Promise((resolve, reject) => { 
            const params = new URLSearchParams();
            if (data.limit) {
                params.append('limit', data.limit);
            }
            if (data.before_timestamp) {
                params.append('before_timestamp', data.before_timestamp);
            }
            
            const url = 'history/chats/' + data.id + '/' + data.jid + (params.toString() ? '?' + params.toString() : '');
            axios.get(url)
            .then(response => {
                commit("PUSH_HISTORY", "OK")
                resolve(response)
            })
            .catch(err => {
                reject(err)
          })
        })
    },
}

const mutations = {
    PUSH_HISTORY(state, data){
        state.history = data
    },
    PUSH_HISTORY_CONTACTS(state, data){
        state.contacts = data
    },
    PUSH_CHAT_LIST(state, data){
        state.chat_lists = data
    },
    PUSH_HISTORY_CHATS(state, data){
        state.chats = data
    },
};


export default {
  state,
  getters,
  actions,
  mutations
};